export default class VgControllerLoader {
    static load(playerType, playerID) {
        return new Promise((resolve, reject) => {
            let i = 0, vgControllerName;
            switch(playerType) {
                case 'v2':
                    vgControllerName = 'ExclusivePlayerV2VideogatewayControllee';
                    break;

                case 'v3':
                    vgControllerName = 'ExclusivePlayerV3VideogatewayControllee';
                    break;

                case 'flash':
                    vgControllerName = 'FlashPlayerVideogatewayControllee';
                    break;

                default:
                    return null;
            }
            const timer = setInterval(() => {
                i++;
                if (typeof Kollus !== 'undefined' && typeof Kollus[vgControllerName] !== 'undefined') {
                    clearInterval(timer);
                    let fn = Kollus[vgControllerName];
                    resolve(new fn(document.getElementById(playerID)));
                }
                if (i > 10) {
                    clearInterval(timer);
                    reject();
                }
            });
        });
    }
}